<script>
import Scheduler from '../components/Scheduler'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'ClassSchedule',
  components: {
    Scheduler
  },
  created () {
    document.title = 'Classes'
    this.fetchInstructors({alreadySelected: this.affiliates, vm: this })
  },
  computed: {
    ...mapState('classes', {
      affiliateFilter: (s) => s.affiliateFilter,
      affiliates: s => s.affiliates,
      filteredAffiliates: s => s.filteredAffiliates
    })
  },
  methods: {
    ...mapActions('classes', [
      'fetchInstructors'
    ]),
    ...mapMutations('classes', [
      'updateAffiliates',
      'updateAffiliateFilter',
      'updateAffiliateToggleState'
    ]),
    checkedInstructorsCount: affiliate => {
      let count = 0
      _.map(affiliate.INSTRUCTORS, instructor => {
        if (instructor.selected === true) {
          count++
        }
      })
      return count
    },
    highlightFilterMatch(val){
      let filter = this.affiliateFilter.trim()
      return val.replace(new RegExp(`${filter}`, "ig"), (match) => `<span class='highlight'>${match}</span>`);
    },
    emitUpdateAffiliates: function (options) {
      this.$root.$emit('schedulerRefresh')
      this.updateAffiliates(options)
    }
  },
}
</script>

<template>
  <q-page id="classes" class="items-stretch">
      <div id="classes-interior" class="row fit">
        <div class="col-auto" style="width:380px;position:relative">
          <div class="row">
            <div class="text-primary text-center pane-text">
              <q-field                
                icon="search">
                <q-input
                  float-label="Search by Affiliate / Instructor"
                  :value="affiliateFilter"
                  :clearable="true"
                  clear-value=""
                  @keyup.stop="updateAffiliateFilter($event.target.value)"
                  @clear="updateAffiliateFilter('')">
                </q-input>
              </q-field>
            </div>
          
            <div id="tree" class="q-tree relative-position text-transparent" style="color:black">
              <q-collapsible v-for="(affiliate, i) in filteredAffiliates" :key="i" v-model="affiliate.open" :class="{'selected':checkedInstructorsCount(affiliate) > 0}">
                <template slot="header" class="q-tree q-tree-node-parent">
                  <div class="q-tree-node-header relative-position row no-wrap items-center q-tree-node-link">
                    <span class="row no-wrap items-center text-black">
                      <div :tabindex="i" class="q-option cursor pointer no-outline row inline no-wrap items-center q-mr-xs q-focusable">
                        <q-checkbox
                          @input="emitUpdateAffiliates({getAffiliates:filteredAffiliates, affiliate: affiliate.AFFILIATE_ID, selected: affiliate.selected})"
                          v-model="affiliate.selected"/>
                      </div>
                      <span class="affiliate-name" :title="affiliate.AFFILIATE_NAME" v-html="highlightFilterMatch(affiliate.AFFILIATE_NAME)"></span>
                      <q-chip v-if="checkedInstructorsCount(affiliate) > 0" detail square dense>{{checkedInstructorsCount(affiliate)}}</q-chip>
                    </span>
                  </div>
                </template>

                <div class="no-results" v-if="!affiliate.INSTRUCTORS[0].USER_ID">
                  No Instructors Available.
                </div>

                <div v-if="affiliate.INSTRUCTORS[0].USER_ID">
                  <div v-for="(instructor, ins) in affiliate.INSTRUCTORS" :key="ins" class="q-tree-node-collapsible text-transparent">
                    <div class="q-tree-children"><div class="q-tree-node q-tree-node-child">
                      <div class="q-tree-node-header relative-position row no-wrap items-center">
                          <span class="row no-wrap items-center text-black">
                            <div tabindex="0" class="q-option cursor-pointer no-outline row inline no-wrap items-center q-mr-xs q-focusable">
                              <div class="q-option-inner relative-position text-transparent">
                                <q-checkbox
                                :title="instructor.USER_FIRST_NAME + ' ' + instructor.USER_LAST_NAME"
                                :label="highlightFilterMatch(instructor.USER_FIRST_NAME + ' ' + instructor.USER_LAST_NAME)"
                                @input="emitUpdateAffiliates({getAffiliates:filteredAffiliates, instructor: instructor.INSTRUCTOR_ID, selected: instructor.selected})"
                                v-model="instructor.selected" />
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> <!-- v-for instructor -->
                </div>
                
              </q-collapsible>
              <div class="no-results" v-if="filteredAffiliates.length === 0">
                No Matching results.
              </div>
            </div>
            
          </div>            
        </div>
        <div class="col">
          <Scheduler />
        </div>
      </div>
      
  </q-page>
</template>

<style lang="stylus">
  @import '~variables'
  .q-collapsible.q-item-division.selected
    background #ffdfdd
  body.desktop .q-tree-node-link:hover
    background transparent
  .q-option-label,
  .affiliate-name
    white-space nowrap
    text-overflow ellipsis
    width 220px
    overflow hidden
  #classes
    background #ffffff
    #classes-interior 
      position absolute
  
  .pane-text
    width 100%
    padding 16px 20px
    color #656565 !important
    border-bottom 1px solid border-color
    i 
      color $primary
      font-weight 400
      display inline-block
      margin-right 5px
      font-size 23px
  #tree
    overflow auto 
    width 380px
    position absolute
    top 115px
    bottom 0
    left 0
  // Tree View
  .q-tree
    width 100%
    .q-option-label
      color black
      line-height 100%
    .q-tree-node-header
      padding 16px 0 16px 20px
      margin-top 0
      width 100%
      position relative
      .q-tree-arrow
        position absolute
        right 11px
        color black
      .q-chip
        position absolute 
        right 0
        background #ff6358
        color #fff
        .q-chip-main
          font-size 15px
          padding 1px 5px
    .q-tree-node-collapsible .q-tree-node-header
      border-bottom none
      margin-top 3px
    .q-checkbox-icon
      color #ff6358
    .q-item-side
      min-width 0
      width 24px
  .no-results
    padding 20px
    font-size 13px
    color #000
    text-align center
  .highlight 
    background #4d83ff
    color #fff
</style>
